// extracted by mini-css-extract-plugin
module.exports = {"VpcDataStores":"VpcDataStores_2jkJN"};